import { TFunction } from "i18next";

export type TimePeriodFilter = "12_months" | "all_time";

export const timePeriodForRecentOnly = (
  showRecentOnly: boolean | undefined
): TimePeriodFilter => {
  return showRecentOnly ? "12_months" : "all_time";
};

export const titleForTimePeriod = (period: TimePeriodFilter, t: TFunction): string => {
  switch (period) {
    case "12_months":
      return t("filterMenu.timePeriod.12Months");
    case "all_time":
      return t("filterMenu.timePeriod.allTime");
    default:
      return t("filterMenu.timePeriod.12Months");
  }
};

export const subtitleForTimePeriod = (period: TimePeriodFilter, t: TFunction): string => {
  switch (period) {
    case "12_months":
      return t("ragStatusCard.last12MonthsSubtitle");
    case "all_time":
      return t("ragStatusCard.allTimeSubtitle");
    default:
      return t("ragStatusCard.last12MonthsSubtitle");
  }
};
